export default "__VITE_ASSET__7nTz8aBX__"